import { render, staticRenderFns } from "./DespesaAutomatica.vue?vue&type=template&id=46a60768&scoped=true"
import script from "./DespesaAutomatica.vue?vue&type=script&lang=js"
export * from "./DespesaAutomatica.vue?vue&type=script&lang=js"
import style0 from "./DespesaAutomatica.vue?vue&type=style&index=0&id=46a60768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a60768",
  null
  
)

export default component.exports